import * as online from './online';

export const operators = {
	...online.operators
};
